import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

/**
 *
 *
 *
 * @returns { roles, loading, error, changePassword };
 */
function useMenus() {
  const [menus, setMenus] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const roles = await dataProvider.getList("menus", {});

        setMenus(roles.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { menus, loading, error };
}

export default useMenus;
